export default __webpack_public_path__ + "static/bg-faqs-e5420c167f577a561471106874276723.jpg";